import type { KeyboardEvent } from 'react';

/**
 * Helper cho InputNumber nhập tiền VND — tách từ CheckoutModal để footer và modal
 * dùng chung (DRY). Định dạng dấu chấm ngăn cách nghìn, chỉ nhận chữ số, cap 12 digit
 * (≈ 1 nghìn tỷ) để tránh Number chuyển sang dạng mũ.
 */
export const MONEY_MAX = 999_999_999_999;

export function moneyFormatter(value?: number | string): string {
  return `${value ?? ''}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

export function moneyParser(display?: string): number {
  const digits = (display ?? '').replace(/\D/g, '').slice(0, 12);
  return digits === '' ? 0 : Number(digits);
}

/**
 * Chặn ký tự không phải chữ số ngay khi gõ + chặn vượt 12 digit (cho phép phím
 * điều hướng/sửa và ghi đè vùng đang chọn).
 */
export function moneyInputKeyDownGuard(e: KeyboardEvent<HTMLInputElement>): void {
  const navKeys = [
    'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight',
    'ArrowUp', 'ArrowDown', 'Tab', 'Enter', 'Home', 'End',
  ];
  if (navKeys.includes(e.key)) return;
  if (e.ctrlKey || e.metaKey) return;
  if (!/^\d$/.test(e.key)) {
    e.preventDefault();
    return;
  }
  const target = e.target as HTMLInputElement;
  const digitCount = target.value.replace(/\D/g, '').length;
  const hasSelection = target.selectionStart !== target.selectionEnd;
  if (digitCount >= 12 && !hasSelection) e.preventDefault();
}
